webpackJsonp([19],{

/***/ "7Rwl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./config/urlprefix.js
var urlprefix = __webpack_require__("Kf48");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/default/unfind.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var unfind = ({
  data: function data() {
    return {
      CurrentEnvPrefix: urlprefix["a" /* CurrentEnvPrefix */]
    };
  },

  methods: {},
  mounted: function mounted() {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (to.path === '/') {
      window.open(urlprefix["a" /* CurrentEnvPrefix */].main);
    } else {
      next();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6026ecef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/default/unfind.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-width":"1200px"}},[_c('div',{staticClass:"unfind-content"},[_c('img',{attrs:{"src":__webpack_require__("NvXF")}}),_vm._v(" "),_c('a',{staticClass:"unfind-refund",attrs:{"href":_vm.CurrentEnvPrefix.main}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var default_unfind = (esExports);
// CONCATENATED MODULE: ./src/components/default/unfind.vue
function injectStyle (ssrContext) {
  __webpack_require__("KoPU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6026ecef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  unfind,
  default_unfind,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_default_unfind = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KoPU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NvXF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404.f8abae2.png";

/***/ })

});


// WEBPACK FOOTER //
// static/js/19.86eed94aeb83073ff6b3.js